// extracted by mini-css-extract-plugin
export default {"MeasureButton":"MeasureButton_MeasureButton__ZPF+e","icon":"MeasureButton_icon__h+qT6","clicked":"MeasureButton_clicked__i6qwO","clickedIcon":"MeasureButton_clickedIcon__PZnte"};